// AIプロンプト設定の画面内の位置（タブ・まとめて生成の実行・ケース）。URL のクエリに持ち、
// 「プロンプトの比較」と「1件ずつ試す」の行き来や再読み込みで同じ状態に戻れるようにする

export type SettingsTab = "versions" | "regression" | "sandbox" | "flows"

export type SettingsLocation = {
  tab: SettingsTab
  /** まとめて生成の実行 ID（プロンプトの比較では表示する実行、1件ずつ試すでは突き合わせる実行） */
  batch?: number | null
  /** 検証ケースの ID */
  case?: number | null
  /** お客様の流れで絞るお客様の督促ケース ID（督促ケース詳細の「検証で追う」から開いたとき） */
  source?: number | null
  /** ケースを開いた元。プロンプトの比較の結果から開いたときは regression（ヘッダーの戻り先を比較の結果にする） */
  from?: "regression" | null
}

/** ページ上部のタブの名前（未保存の確認で「〜を開きますか？」にも使う） */
export const SETTINGS_TAB_LABELS: Record<SettingsTab, string> = {
  versions: "プロンプト管理",
  regression: "プロンプトの比較",
  sandbox: "1件ずつ試す",
  flows: "お客様の流れ",
}

/** replace は同じタブの中での選び直し（履歴を増やさない）、それ以外はタブをまたぐ移動 */
export type Locate = (location: SettingsLocation, options?: { replace?: boolean }) => void

/**
 * タブをまたいで移る前に通す関門。未保存の変更がある画面（1件ずつ試す・お客様の流れ）が登録し、
 * ページ上部のタブの切り替えもケースを開き直すときと同じ確認を通す。null で登録を外す
 */
export type RegisterLeaveGuard = (guard: ((to: SettingsLocation) => void) | null) => void

export const SETTINGS_PATH = "/admin/dunning-prompt-settings"

const TABS: SettingsTab[] = ["versions", "regression", "sandbox", "flows"]
/** 「プロンプトの比較」に統合した旧「まとめて評価」タブ（tab=batch）。以前の URL はプロンプトの比較で開く */
export const LEGACY_BATCH_TAB = "batch"

const positiveId = (value: string | string[] | undefined) => {
  const number = Number(Array.isArray(value) ? value[0] : value)
  return Number.isInteger(number) && number > 0 ? number : null
}

export const parseSettingsQuery = (
  query: Record<string, string | string[] | undefined>
): SettingsLocation => {
  const tab = Array.isArray(query.tab) ? query.tab[0] : query.tab
  return {
    tab:
      tab === LEGACY_BATCH_TAB
        ? "regression"
        : TABS.includes(tab as SettingsTab)
          ? (tab as SettingsTab)
          : "versions",
    batch: positiveId(query.batch),
    case: positiveId(query.case),
    source: positiveId(query.source),
    from:
      (Array.isArray(query.from) ? query.from[0] : query.from) === "regression"
        ? "regression"
        : null,
  }
}

export const settingsQuery = (location: SettingsLocation): Record<string, string> => ({
  tab: location.tab,
  ...(location.batch ? { batch: String(location.batch) } : {}),
  ...(location.case ? { case: String(location.case) } : {}),
  ...(location.source ? { source: String(location.source) } : {}),
  ...(location.from ? { from: location.from } : {}),
})

export const settingsHref = (location: SettingsLocation) =>
  `${SETTINGS_PATH}?${new URLSearchParams(settingsQuery(location)).toString()}`
